export default "__VITE_ASSET__BW7F_Q3O__"